import httpClient from '../httpClient';

export async function getAllAquisicoes() {
  try {
    const response = await httpClient.get(`/api/aquisicoes`);

    // Aqui corrige para aceitar retorno direto
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}
